import { getWindowSafe } from '@change-corgi/core/window';

const window = getWindowSafe();

export const KEEPALIVE_SUPPORTED = (() => {
	try {
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		return !!window && !!window.Request && 'keepalive' in new window.Request('');
	} catch (err) {
		return false;
	}
})();

export function isKeepaliveSupported(): boolean {
	return KEEPALIVE_SUPPORTED;
}

export function isSendBeaconSupported(): boolean {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	return !!window && !!window.navigator?.sendBeacon;
}
